
















import { Component, Prop, Vue } from 'vue-property-decorator';

import { ProductCharacter } from '@/store/modules/lib';

@Component
export default class ProductCharacterItem extends Vue {

  @Prop({ type: Boolean, default: false }) protected noBorder!: boolean;
  @Prop({ type: Object, default: {} }) protected character!: ProductCharacter;

}

